export default __webpack_public_path__ + "static/media/Stu.011ea780.jpg";